export default "__VITE_ASSET__BhMHFcgN__"